<template>
  <v-btn-toggle
    divided
    mandatory
    class="toggle"
  >
    <v-btn
      :class="valueButton"
      class="custom-btn"
      density="compact"
      @click="updateValue(false)"
    >
      <v-icon
        size="large"
        :color="!isPercentage ? 'var(--ds-color-icon-interactive)' : 'var(--ds-color-gray-3)'"
        class="icon"
      >
        mdi-pound
      </v-icon>
    </v-btn>
    <v-btn
      :class="percentageButton"
      class="custom-btn"
      @click="updateValue(true)"
    >
      <v-icon
        size="large"
        :color="isPercentage ? 'var(--ds-color-icon-interactive)' : 'var(--ds-color-gray-3)'"
        class="icon"
      >
        mdi-percent
      </v-icon>
    </v-btn>
  </v-btn-toggle>
</template>

<script>

export default {
  name: 'ToggleData',
  props: {
    isPercentage: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    percentageButton() {
      if (this.isPercentage) {
        return 'toggle__btn-selected';
      }
      return 'toggle__btn';
    },
    valueButton() {
      if (this.isPercentage) {
        return 'toggle__btn';
      }
      return 'toggle__btn-selected';
    },
  },
  methods: {
    updateValue(newValue) {
      this.$emit('update:isPercentage', newValue);
    },
  },
};
</script>

<style scoped lang="scss">
  .toggle {
    border-radius: 4px;
    border: 1px solid var(--ds-color-gray-3);
    margin-right: 16px;

    &__btn-selected {
      background: #233033 !important;
    }
  }

  .custom-btn {
    padding: 0 !important;
    min-width: 24px !important;
    height: 24px !important;
  }

</style>
